import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding-top: 40px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;
export const ContentRowAccordion = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;

export const ContainerAlignColumn = styled.div`
  display: flex;
  flex-direction: column;
`;
export const AlignTitle = styled.div`
  margin-bottom: 12px;
`;

export const ContainerColumnRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 11.875rem;
  border: 1px solid #e1e1e1;
`;

export const ContentDescription = styled.div`
  width: 30%;
  padding: 0 0 0 10px;
`;

export const ContentRow = styled.div`
  display: grid;
  grid-template-columns: 0.3fr 1fr 0.3fr 1fr;
  height: 100%;
  width: 100%;

  ${({ index }) =>
    index % 2 === 1 &&
    css`
      background-color: #b6bfc8;
    `}
`;

export const ContentWraper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContentTitleWraper = styled.div`
  position: absolute;
  margin-bottom: 210px;
`;
